/**
 * Based on https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-widget-connector/browse/src/main/resources/com/atlassian/confluence/extra/widgetconnector/js/autoconvert-twitter.js
 */
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
import window from 'window-or-global';

const singleStatusTweetRegex = /^\/(.*?)\/status\/([^/]+\/?$)/,
	singleStatusesTweetRegex = /^\/(.*?)\/statuses\/([^/]+\/?$)/;

const pasteHandler = (uri, node, done) => {
	let match, newUrl, macro;

	if (uri.host.match(/^twitter.com/)) {
		if ((match = decodeURI(uri.path).match(singleStatusTweetRegex))) {
			newUrl = `${uri.protocol}://twitter.com/${match[1]}/status/${match[2]}`;
		} else if ((match = decodeURI(uri.path).match(singleStatusesTweetRegex))) {
			newUrl = `${uri.protocol}://twitter.com/${match[1]}/statuses/${match[2]}`;
		}

		if (newUrl) {
			macro = { name: 'widget', params: { url: newUrl } };
			window.tinymce.plugins.Autoconvert.convertMacroToDom(macro, done, done);
		} else {
			done();
		}
	} else {
		done();
	}
};

export default () => {
	bind('init.rte', () => window.tinymce.plugins.Autoconvert.autoConvert.addHandler(pasteHandler));
};
